"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var dyna_interfaces_1 = require("dyna-interfaces");
var envGlobal_1 = require("../utils/envGlobal");
var DynaNodeAddress_1 = require("../DynaNodeAddress/DynaNodeAddress");
var DynaNodeServerAPI_1 = require("./DynaNodeServerAPI");
var consoleStringify_1 = require("../utils/consoleStringify");
var createDynamicDynaNodeAddress_1 = require("../utils/createDynamicDynaNodeAddress");
var DynaNodeLocalInstanceServer = /** @class */ (function () {
    function DynaNodeLocalInstanceServer(_config) {
        var _this = this;
        this._config = _config;
        this._connections = {};
        this._active = false;
        this.getServerAddresses = function () {
            return new Array()
                .concat(_this._config.addresses.internal, _this._config.addresses.external || "", _this._config.addresses.externals || [])
                .filter(Boolean);
        };
        this._postMessage = function (message, cbCompleted) {
            if (message.replyOf) {
                message.from = message.replyOf.to;
            }
            else {
                message.from = _this._config.addresses.internal;
            }
            _this._dispatch(message);
            cbCompleted && cbCompleted();
        };
        this._registerClient = function (args) {
            var connectionId = createDynamicDynaNodeAddress_1.createDynamicDynaNodeAddress();
            var connection = _this._connections[connectionId] = {
                connectionId: connectionId,
                sendToConnection: function (outputMessage) {
                    args.onReceive(outputMessage);
                },
            };
            return {
                send: (function (message) {
                    // This is the input of the incoming message
                    // Overwrite the from address, use the connection.connectionId since this is update from the checkConnectionId request
                    message.from = connection.connectionId + "@" + _this._config.addresses.internal;
                    _this._dispatch(message);
                }),
                unregister: function () { return _this._unregisterClient(connectionId); },
            };
        };
        this._changeConnectionIdForService = function (currentConnectionId, newConnectionid) {
            _this._connections[newConnectionid] = _this._connections[currentConnectionId];
            _this._connections[newConnectionid].connectionId = newConnectionid;
            delete _this._connections[currentConnectionId];
        };
        this._bridge = {
            register: this._registerClient,
        };
        new Array()
            .concat(this._config.addresses.internal, this._config.addresses.external || "", this._config.addresses.externals || [])
            .filter(Boolean)
            .forEach(function (address) { return envGlobal_1.envGlobal[encodeURI("_dnsic_" + address)] = _this._bridge; });
        this._externalAddresses = new Array()
            .concat(this._config.addresses.external || "", this._config.addresses.externals || [])
            .filter(Boolean);
        this._api = new DynaNodeServerAPI_1.DynaNodeServerAPI({
            postMessage: this._postMessage,
            connectionIds: this._config.connectionIds,
            getStats: function () { return _this.stats; },
            getServerAddresses: this.getServerAddresses,
            changeConnectionIdForService: this._changeConnectionIdForService,
        });
    }
    DynaNodeLocalInstanceServer.prototype.start = function () {
        this._active = true;
        return Promise.resolve();
    };
    DynaNodeLocalInstanceServer.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._active = false;
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(DynaNodeLocalInstanceServer.prototype, "stats", {
        get: function () {
            return {
                time: (new Date()).toISOString(),
                connections: Object.keys(this._connections),
                internalDNAddress: this._config.addresses.internal,
                externalDNAddresses: new Array()
                    .concat(this._config.addresses.external || "", this._config.addresses.externals || [])
                    .filter(Boolean),
                memory: process.memoryUsage(),
            };
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeLocalInstanceServer.prototype._unregisterClient = function (connectionId) {
        delete this._connections[connectionId];
    };
    // @ts-ignore Ideally the old connection would be dropped
    DynaNodeLocalInstanceServer.prototype._closeConnection = function (connectionId) {
        this._unregisterClient(connectionId);
    };
    DynaNodeLocalInstanceServer.prototype._dispatch = function (message) {
        if (!this._active)
            return;
        if (this._config._debug_consoleDispatches) {
            console.log('DynaNodeLocalInstanceServer info: dispatch from: ' + message.from + ' to: ' + message.to + ' command: ' + message.command, consoleStringify_1.consoleStringify(message.viewSecure));
        }
        if (message.to === this._config.addresses.internal
            || this._externalAddresses.includes(message.to)) {
            this._api.processMessage(message);
            return;
        }
        var toAddress = new DynaNodeAddress_1.DynaNodeAddress(message.to);
        var connection = toAddress.connectionId && this._connections[toAddress.connectionId] || null;
        var sendToConnection = connection && connection.sendToConnection;
        if (sendToConnection) {
            message._addTrace('DynaNode/Server(local)/DISPATCH_SUCCESS', "DynaNodeServer(local): Dispatch to connection", this._traceData);
            sendToConnection(message);
        }
        else {
            message._addTrace('DynaNode/Server(local)/DISPATCH_ERROR_404', "DynaNodeServer: Reply with 404 error", this._traceData);
            var replyMessage = message.reply({
                command: "error/dyna-node/404/101",
                args: null,
                data: {
                    code: 404.101,
                    section: "DynaNodeLocalInstanceServer/dispatch",
                    errorType: dyna_interfaces_1.EErrorType.USER,
                    message: "The recipient " + message.to + " does not exist here. The incoming message is at replyOf.",
                },
                updateReplyOfArgs: true,
                updateReplyOfData: true,
                updateReplyOfReplyOf: true,
            });
            replyMessage.from = (new DynaNodeAddress_1.DynaNodeAddress(replyMessage.to)).serverAddress;
            this._dispatch(replyMessage);
        }
    };
    Object.defineProperty(DynaNodeLocalInstanceServer.prototype, "_traceData", {
        get: function () {
            return {
                dynaNodeServerName: this._config.name || '-no name-',
            };
        },
        enumerable: true,
        configurable: true
    });
    return DynaNodeLocalInstanceServer;
}());
exports.DynaNodeLocalInstanceServer = DynaNodeLocalInstanceServer;
//# sourceMappingURL=DynaNodeLocalInstanceServer.js.map